var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRightLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m17.537.3-1.243 1.19 3.797 3.96H.7v1.73h19.358l-3.763 3.932 1.243 1.189 5.764-6-5.764-6Z",
  fill: "#1A1A1A"
})));
export default SvgArrowRightLarge;